import Vue from 'vue'
import VueRouter from 'vue-router'
import CustomerView from '../views/CustomerView.vue'
import StaffView from '../views/StaffView.vue'

import StaffMenu from '../components/StaffMenu.vue'

import ServiceRecordList from '../components/servicerecord/serviceRecordList.vue'
import ServiceRecord from '../components/servicerecord/serviceRecord.vue'

Vue.use(VueRouter)

const routes = [
  // user path
  {
    path: '/customer*',
    name: 'CustomerView',
    component: CustomerView
  },
  // stafff path
  {
    path: '/staff/menu',
    component: StaffMenu
  },
  {
    path: '/staff/service_records',
    component: ServiceRecordList,
    meta: {
      keepAlive: true,
      scrollTop: 0
    }
  },
  {
    path: '/staff/service_records/edit/:id',
    component: ServiceRecord,
    meta: {
      action: 'edit'
    }
  },
  {
    path: '/staff/service_records/review/:id',
    component: ServiceRecord,
    meta: {
      action: 'review'
    }
  },
  {
    path: '/staff/service_records/view/:id',
    component: ServiceRecord,
    meta: {
      action: 'view'
    }
  },
  {
    path: '/staff*',
    name: 'StaffView',
    component: StaffView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from, next) => {
  if (from.path !== '/' && !from.path.includes('/staff/service_records') && !from.path.includes('/staff/menu')) {
    location.reload()
  }
})

export default router
